import { Link } from 'react-router-dom';

import { BUSINESS_DISPLAY } from '../../config/business';

const footerLinks = [
  { to: '/origins', label: '서비스 소개' },
  { to: '/archives', label: '이용안내' },
  { to: '/business-info', label: '사업자 정보' },
  { to: '/terms', label: '이용약관' },
  { to: '/privacy', label: '개인정보처리방침' },
  { to: '/refund', label: '환불정책' },
  { to: '/credits', label: '제작 정보' },
  { to: '/contact', label: '문의' },
] as const;

interface SiteFooterNavProps {
  className?: string;
  linkClassName?: string;
  emailClassName?: string;
  onCookieSettingsClick?: () => void;
}

export function SiteFooterNav({
  className,
  linkClassName,
  emailClassName,
  onCookieSettingsClick,
}: SiteFooterNavProps) {
  const navClassName =
    className ?? 'flex flex-wrap items-center gap-x-4 gap-y-2 text-sm leading-6 text-[#ddc8a6]';
  const navLinkClassName = linkClassName ?? 'transition hover:text-[#fff1c8]';
  const contactClassName = emailClassName ?? 'text-xs leading-6 tracking-[0.08em] text-[#8c6d42]';

  return (
    <div className="space-y-4">
      <div className={navClassName}>
        {footerLinks.map((link) => (
          <Link
            key={link.to}
            className={navLinkClassName}
            to={link.to}
          >
            {link.label}
          </Link>
        ))}
        {onCookieSettingsClick ? (
          <button
            className={navLinkClassName}
            onClick={onCookieSettingsClick}
            type="button"
          >
            쿠키 설정
          </button>
        ) : null}
      </div>

      <div className={contactClassName}>
        <span>문의: {BUSINESS_DISPLAY.email}</span>
        <span className="mx-2">|</span>
        <span>대표번호: {BUSINESS_DISPLAY.phone}</span>
      </div>
    </div>
  );
}

export default SiteFooterNav;
